import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3544664266/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/product/[id]/_components/product.tsx");
